import useUploadImageService from 'api/services/uploadImageService'
import { ChangeEvent, useState } from 'react'
import { useMutation } from 'react-query'
import { UploadStatus } from 'types/general'

import FileDropZone from './FileDropZone'

type FileUploaderProps = {
  label: string
  name: string
  accept?: string
  multiple?: boolean
  allowPdf?: boolean
  onUploadSuccess: (urls: string[]) => void
}

const FileUploader = ({
  label,
  name,
  accept,
  multiple,
  allowPdf,
  onUploadSuccess,
}: FileUploaderProps) => {
  const [currentStatus, setCurrentStatus] = useState<UploadStatus>(
    UploadStatus.Idle
  )

  const { uploadImage } = useUploadImageService()

  const { mutateAsync: uploadFilesMutation } = useMutation<
    { urls: string[] },
    Error,
    any
  >(uploadImage)

  const uploadFiles = async (filesToUpload: File[]) => {
    setCurrentStatus(UploadStatus.Uploading)
    const formData = new FormData()

    filesToUpload.forEach(file => {
      formData.append('images[]', file)
    })

    try {
      const { urls } = await uploadFilesMutation(formData)

      onUploadSuccess(urls)
      setCurrentStatus(UploadStatus.Success)
    } catch (error) {
      console.error('Upload failed', error)
      setCurrentStatus(UploadStatus.Error)
    }
  }

  const handleImageChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const fileList = e.target.files
    if (fileList && fileList.length > 0) {
      const filesArray = Array.from(fileList)
      uploadFiles(filesArray)
    }
  }

  const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    const fileList = e.dataTransfer.files
    if (fileList && fileList.length > 0) {
      const filesArray = Array.from(fileList)
      uploadFiles(filesArray)
    }
  }

  return (
    <FileDropZone
      label={label}
      name={name}
      accept={accept}
      multiple={multiple}
      allowPdf={allowPdf}
      onChange={handleImageChange}
      onDrop={handleDrop}
      uploadStatus={currentStatus}
    />
  )
}

export default FileUploader
